<dx-popup #dlgClientPhoto [width]="400" [height]="375" [showTitle]="true" [title]="this.title" [resizeEnabled]=true
    [dragEnabled]="true" [showCloseButton]="true" [hideOnOutsideClick]="false">
    
    <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="CancelButtonOptions">
    </dxi-toolbar-item>

    <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="TakePictureButtonOptions">
    </dxi-toolbar-item>    

    <div *dxTemplate="let data of 'content'">
        <dx-load-indicator
            [(visible)]="isLoadIndicatorVisible"
            [height]="40"
            [width]="40">
        </dx-load-indicator>
        <webcam class="widget-container flex-box" [height]="225" [width]="300" [trigger]=" triggerObservable"
            (imageCapture)="handleImage($event)" *ngIf="showWebcam" [allowCameraSwitch]="allowCameraSwitch"
            [switchCamera]="nextWebcamObservable" [videoOptions]="videoOptions"
            (cameraSwitched)="cameraWasSwitched($event)" (initError)="handleInitError($event)"></webcam>
    </div>
</dx-popup>